import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import RegioniMap from './RegioniMap';

const nf = (n) => (n || 0).toLocaleString('it-IT');

export default function RegioniPage() {
  const [regioni, setRegioni] = useState({});
  const [sel, setSel] = useState(null);

  useEffect(() => {
    axios.get(`${API}/analisi/geo`).then((r) => setRegioni(r.data?.regioni || {})).catch(() => {});
  }, []);

  const onSelect = useCallback((key) => setSel(key), []);
  const d = sel ? (regioni[sel] || {}) : null;

  return (
    <div className="m-regioni">
      <RegioniMap regioni={regioni} onSelect={onSelect} />
      {sel && (
        <div className="m-reg-overlay" onClick={() => setSel(null)}>
          <div className="m-reg-card" onClick={(e) => e.stopPropagation()}>
            <div className="m-reg-head"><span>{sel}</span><button onClick={() => setSel(null)}>✕</button></div>
            <div className="m-reg-grid">
              <div><b>{nf(d.totale)}</b><span>Caricati</span></div>
              <div><b>{nf(d.tim)}</b><span>TIM</span></div>
              <div><b>{nf(d.nontim)}</b><span>NON TIM</span></div>
              <div><b>{nf(d.esportati)}</b><span>Esportati</span></div>
              <div><b>{nf(d.pending_456)}</b><span>Da verificare 456</span></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
